module.exports = __webpack_public_path__ + "static/media/download.08a6b743.svg";